/*
 | -------------------------------------------------------------
 |  --> type: component
 |  --> name: dropdown
 | -------------------------------------------------------------
 |
 |  Functionality for elements that contain a dropdown menu.
 |
*/

/* -------------------------------------------------------------
 | variables
 | -------------------------------------------------------------
 */

const dropdownToggles = document.querySelectorAll('[data-dropdown="parent"]') // select parent element of the dropdown

/* -------------------------------------------------------------
 | functions
 | -------------------------------------------------------------
 */

const isOutOfViewport = (element) => {
  // get element's bounding
  const bounding = element.getBoundingClientRect()

  // check if it's out of the viewport on the right side
  return bounding.right > (window.innerWidth || document.documentElement.clientWidth)
}

// open specific dropdown
const openDropdown = (dropdownToggle) => {
  const dropdownMenu = dropdownToggle.parentNode.querySelector('[data-dropdown="child"]') // select the dropdown that is a sibling of the clicked toggle

  dropdownToggle.classList.add('open')
  dropdownToggle.setAttribute('aria-expanded', 'true')

  dropdownMenu.classList.add('show')

  // if navigationDropdown is outside page => addClass align-right
  if (isOutOfViewport(dropdownMenu)) {
    dropdownMenu.classList.add('align-right')
  }
}

// close specific dropdown
const closeDropdown = (dropdownToggle) => {
  const dropdownMenu = dropdownToggle.parentNode.querySelector('[data-dropdown="child"]') // select the dropdown that is a sibling of the clicked toggle

  dropdownToggle.classList.remove('open')
  dropdownToggle.setAttribute('aria-expanded', 'false')

  dropdownMenu.classList.remove('show')
  dropdownMenu.classList.remove('align-right')
}

// close all dropdowns
const closeAllDropdowns = () => {
  for (let i = 0; i < dropdownToggles.length; i++) {
    closeDropdown(dropdownToggles[i])
  }
}

// toggle dropdowns after click. Used by event listener
const toggleDropdown = (event) => {
  if (event.target.getAttribute('aria-expanded') === 'false') {
    closeAllDropdowns()
    openDropdown(event.target)
  } else {
    closeDropdown(event.target)
  }
}

/* -------------------------------------------------------------
 | execution
 | -------------------------------------------------------------
 */

/*
 1. search the DOM for elements with a data-dropdown attribute
 2. add an event listener to the dropdown element
 3. toggle a class 'show' when the dropdown element is clicked
 4. set aria-expanded either true or false depending on the state
*/

// bind click event to all toggles
if (dropdownToggles) {
// maybe use a foreach?
  for (let i = 0; i < dropdownToggles.length; i++) {
    dropdownToggles[i].addEventListener('click', toggleDropdown)
  }

  window.addEventListener('click', (event) => {
    if (!event.target.hasAttribute('data-dropdown')) {
      closeAllDropdowns()
    }
  })
}
